import { PersistedState } from 'redux-persist';

interface LegacyAuthState {
  lastActivity?: number | null;
  [key: string]: unknown;
}

type LegacyPersistedState = NonNullable<PersistedState> & {
  auth?: LegacyAuthState;
  [key: string]: unknown;
};

export const migrations = {
  0: (state: PersistedState): PersistedState => {
    const legacyState = state as LegacyPersistedState;
    if (!legacyState.auth) return state;

    const { lastActivity: _lastActivity, ...auth } = legacyState.auth;

    return {
      ...legacyState,
      auth,
    } as unknown as PersistedState;
  },
};
